import {
    isoAndUnixZodSchema,
    nowIsoAndUnix,
} from "@@/shared/date-time/iso-and-unix";
import { idZodSchema } from "@@/shared/id";
import { generateId } from "@@/utilities/generate-id";
import type { Except } from "type-fest";
import { z } from "zod";
import { categoryZodObject } from "./category";

const addCategoryCommandZodObject = z.object({
    _id: idZodSchema,
    _type: z.literal("ADD_CATEGORY_COMMAND"),
    _createdAt: isoAndUnixZodSchema,
    category: categoryZodObject,
});

type AddCategoryCommand = z.infer<typeof addCategoryCommandZodObject>;
const addCategoryCommandZodScheme =
    addCategoryCommandZodObject as z.ZodSchema<AddCategoryCommand>;

type FactoryParams = Except<AddCategoryCommand, "_id" | "_type" | "_createdAt">;
const addCategoryCommandFactory = (params: FactoryParams) => {
    const command: AddCategoryCommand = {
        ...params,
        _id: generateId({ prefix: "add_category_command__" }),
        _type: "ADD_CATEGORY_COMMAND",
        _createdAt: nowIsoAndUnix(),
    };
    return command;
};

export {
    addCategoryCommandFactory,
    addCategoryCommandZodObject,
    addCategoryCommandZodScheme,
};
export type {
    AddCategoryCommand,
    FactoryParams as AddCategoryCommandFactoryParams,
};
